export default "__VITE_ASSET__C55Xduw9__"